class NavController {

  constructor($state) {
    'ngInject';

    this.$state = $state;
    this.navItems = [
      'concept',
      'live_course',
      'online_course',
      'workbook_course',
      'summary_app',
      'textbook',
      'barbara_minto',
      'contact'
    ];
  }

  goTo(item) {
    this.$state.go(`site.${item}`);
  }

}

export default NavController;



// WEBPACK FOOTER //
// ./client/app/components/nav/nav.controller.js